export default [
  {
    primaryTitle: 'Administrating Eternity',
    secondaryTitle: ' ',
    year: 2011,
    description: require('./markdown/descriptionartwork/administeringeternity.md'),
    excerpt: '',
    image: require('./images/works/Administrating-Eternity-2011-square.jpg'),
  },

  {
    primaryTitle: 'Japsen',
    secondaryTitle: '',
    year: 1988,
    description: require('./markdown/descriptionartwork/japsen.md'),
    excerpt: '',
    image: require('./images/works/Japsen.jpg'),
  },

  {
    primaryTitle: 'I\'m Not The Girl Who Misses Much',
    secondaryTitle: '',
    year: 1986,
    description: require('./markdown/descriptionartwork/imnotthegirl.md'),
    excerpt: '',
    image: require('./images/works/RIST-01-not-the-girl_square2.jpg'),
    /*video: '224281358',*/
  },

  {
    primaryTitle: 'Ever is Over all',
    secondaryTitle: '',
    year: 1996,
    description: require('./markdown/descriptionartwork/everisoverall.md'),
    excerpt: '',
    image: require('./images/works/Ever-Is-Over-All-smash_square.jpg'),
  },

  {
    primaryTitle: '4th Floor to Mildness',
    secondaryTitle: ' ',
    year: 2016,
    description: require('./markdown/descriptionartwork/4thfloortomildness.md'),
    excerpt: '',
    image: require('./images/works/4th-FLOOR_VIEW-6_SCALE-A_square.jpg'),
  },

  {
    primaryTitle: 'Sip my ocean',
    secondaryTitle: ' ',
    year: 1997,
    description: require('./markdown/descriptionartwork/sipmyocean.md'),
    excerpt: '',
    image: require('./images/works/sip-new-105-cmyk_square.jpg'),
  },

  {
    primaryTitle: 'Lobe of the Lung',
    secondaryTitle: '',
    year: 2009,
    description: require('./markdown/descriptionartwork/lobeofthelung.md'),
    excerpt: '',
    image: require('./images/works/Lobeofthelung.jpg'),
  },

  {
    primaryTitle: 'Pixelwald (Pixel Forest)',
    secondaryTitle: '',
    year: 2016,
    description: require('./markdown/descriptionartwork/pixelforest.md'),
    excerpt: '',
    image: require('./images/works/MCA---Pipilotti-Rist---Pixel-Forest,-2016-RECROP_square.jpg'),
  },

  {
    primaryTitle: 'Your Room opposite the Opera',
    secondaryTitle: ' ',
    year: 2017,
    description: require('./markdown/descriptionartwork/enlightmyspace.md'),
    excerpt: '',
    image: require('./images/works/Enlight-My-Space_DSC2636__b_square.jpg'),
  },
]



// WEBPACK FOOTER //
// ./src/Rist/content/works.js